
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/core-program-terms-of-use",
      function () {
        return require("private-next-pages/legal/core-program-terms-of-use.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/core-program-terms-of-use"])
      });
    }
  